import React, { useEffect } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { ControlledHiddenInput } from 'transfix-form/components'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import { makeStyles, Typography } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { TResolutionSteps } from './types'

export interface IEditIssueStepsProps {
  resolutionSteps?: TResolutionSteps[] | null
  showTitle?: boolean
}

const useEditIssueStepsToResolveStyles = makeStyles(theme => ({
  title: {
    marginTop: theme.spacing(3),
  },
}))

export const EditIssueStepsToResolve = ({
  resolutionSteps,
  showTitle = false,
}: IEditIssueStepsProps) => {
  const styles = useEditIssueStepsToResolveStyles()
  const isMpStepsToResolveEnabled = useFeatureFlag('mpStepsToResolve')
  const { control, setValue } = useFormContext()
  const { fields } = useFieldArray({
    control,
    name: 'issueResolutionSteps',
  })

  useEffect(() => {
    if (resolutionSteps) {
      setValue('issueResolutionSteps', resolutionSteps)
    }
  }, [resolutionSteps, setValue])

  if (!isMpStepsToResolveEnabled) return null

  return (
    <div>
      {showTitle && (
        <Typography className={styles.title} variant='subtitle1'>
          Steps To Resolve
        </Typography>
      )}
      <Typography variant='caption' color='textSecondary'>
        Checkoff completed steps
      </Typography>
      {fields.map((item, index) => (
        <>
          <ControlledCheckbox
            name={`issueResolutionSteps.${index}.completed`}
            CheckboxProps={{
              label: item.description,
            }}
            defaultValue={item.completed}
            key={item.id}
          />
          <ControlledHiddenInput name={`issueResolutionSteps.${index}.id`} defaultValue={item.id} />
        </>
      ))}
    </div>
  )
}

export default EditIssueStepsToResolve
